'use memo'

import {
  AgxButton,
  AgxDatePicker,
  AgxModal,
  AgxRadioGroup,
  AgxSpacer,
  Icon_AlertCircleOutline,
} from '@urbanx/agx.ui-components2'
import { useContractTerminate } from './useContractTerminate'
import { AgxFileUpload } from '@urbanx/agx-ui-components'
import { DocumentTypes } from '@urbanx/agx.campaigns.client'
import { deleteFile, getFileLink } from 'services'

interface Props {
  isOpen: boolean
  setIsOpen: (_value: boolean) => void
}
const ContractTerminateModal = (props: Props) => {
  const { isOpen, setIsOpen } = props
  const {
    onTerminateConfirm,
    depositOptions,
    reasonOptions,
    canSubmit,
    onDateChange,
    onUploadFile,
    getAuthToken,
    selectedCampaign,
    vendorTerminationConfirmationFiles,
    buyerTerminationConfirmationFiles,
    onVendorTerminationConfirmationChanged,
    onBuyerTerminationConfirmationChanged,
    onDepositOptionChange,
    onReasonChange,
    selectedDepositOption,
    selectedReason,
    selectedTerminationDate,
  } = useContractTerminate({
    isOpen,
    setIsOpen,
  })

  return (
    <AgxModal
      title={'Mark as Terminated'}
      titleIcon={
        <div className="modelTitleIconContainer">
          <Icon_AlertCircleOutline type={'Danger'} height={40} width={40} />
        </div>
      }
      type={'fullHeight'}
      variant={'withDivider'}
      actionButtonContainerStyle={'withDivider'}
      actionButtons={
        <AgxSpacer
          direction="horizontal"
          gap={'spacing-xl'}
          contentJustification="center"
          fill
        >
          <AgxButton
            id={'btnCancel'}
            text={'Cancel'}
            variant={'hollow'}
            onClick={() => setIsOpen(false)}
            stretch
          />
          <AgxButton
            id={'btnConfirm'}
            text={'Confirm'}
            variant={'primary'}
            danger
            disabled={!canSubmit}
            onClick={onTerminateConfirm}
            stretch
          />
        </AgxSpacer>
      }
      content={
        <AgxSpacer
          direction="vertical"
          gap={'md'}
          fill
          padding={{ top: 'md', bottom: 'md', left: 'xl', right: 'xl' }}
        >
          <AgxDatePicker
            id={'dateOfTermination'}
            label="Date of Termination"
            optionalText=""
            stretch
            required
            value={selectedTerminationDate}
            onChange={onDateChange}
          />
          <AgxFileUpload
            title="Vendor Termination Confirmation"
            id="fileVendorTerminationConfirmation"
            documentType={DocumentTypes.ExchangeLetter}
            buttonText={'Choose file'}
            fileData={vendorTerminationConfirmationFiles}
            onValueChanged={onVendorTerminationConfirmationChanged}
            getAuthToken={getAuthToken}
            campaignId={selectedCampaign?.campaignId || ''}
            uploadFile={onUploadFile}
            deleteFile={deleteFile}
            getFileLink={getFileLink}
            extensions={['pdf']}
            multiple={false}
            autoUpload={false}
            required
          />
          <AgxFileUpload
            title="Buyer Termination Confirmation"
            id="fileBuyerTerminationConfirmation"
            documentType={DocumentTypes.ExchangeLetter}
            buttonText={'Choose file'}
            fileData={buyerTerminationConfirmationFiles}
            onValueChanged={onBuyerTerminationConfirmationChanged}
            getAuthToken={getAuthToken}
            campaignId={selectedCampaign?.campaignId || ''}
            uploadFile={onUploadFile}
            deleteFile={deleteFile}
            getFileLink={getFileLink}
            extensions={['pdf']}
            multiple={false}
            autoUpload={false}
            required
          />
          <AgxRadioGroup
            label="Who is entitled to the deposit"
            id={'whosEntitledToDeposit'}
            layout="vertical"
            options={depositOptions}
            value={selectedDepositOption}
            onChange={onDepositOptionChange}
            required
          ></AgxRadioGroup>
          <AgxRadioGroup
            label="Reason"
            id={'reason'}
            layout="vertical"
            options={reasonOptions}
            value={selectedReason}
            onChange={onReasonChange}
            required
          ></AgxRadioGroup>
        </AgxSpacer>
      }
      isOpen={isOpen}
      setIsDialogOpen={setIsOpen}
    />
  )
}

export default ContractTerminateModal
